export default {"src":"/_next/static/media/profileIcon.48fac3aa.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};